module.exports = {
  "country": "SM",
  "artist": "Valentina Monetta",
  "song": "The Social Network Song",
  "year": "2012",
  "place": "NQ",
  "spotify": "0Vzs9Npd4fvkRi3utSF2E3"
};